export const ORGANIZATION_CODE_DIGITS = 6;

export function formatOrganizationCode(code: number): string {
  return String(code).padStart(ORGANIZATION_CODE_DIGITS, "0");
}

export function formatOrganizationLabel(code: number, name: string): string {
  return `${formatOrganizationCode(code)} — ${name}`;
}

export function formatOrganizationSubtitle(code: number, slug: string): string {
  return `${formatOrganizationCode(code)} · ${slug}`;
}

export function formatOrganizationRoleLine(input: {
  isSuperAdmin: boolean;
  code?: number;
  name: string;
}): string {
  const org =
    input.name.trim().length > 0
      ? typeof input.code === "number"
        ? `${formatOrganizationCode(input.code)} · ${input.name.trim()}`
        : input.name.trim()
      : "";
  if (input.isSuperAdmin) {
    return org ? `מנהל מערכת · ${org}` : "מנהל מערכת";
  }
  return org || "אין ארגון פעיל";
}
